import { h } from 'vue';
import { type IconProps , type IconSet } from 'vuetify';

import china from './china.vue';
import france from './france.vue';
import germany from './germany.vue';
import greatBritain from './greatBritain.vue';
import italy from './italy.vue';
import spain from './spain.vue';

const flags = {
    'de-DE': germany,
    // This one hurts
    'en-US': greatBritain,
    'es-ES': spain,
    'fr-FR': france,
    'it-IT': italy,
    'zh-CN': china
};

export const flagsSet: IconSet = {
    component: (props: IconProps) => h(flags[props.icon as keyof typeof flags])
};